import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../services/proto/core/loginProps';

export const getUserFullName = async (nickName: string) => {
    const form = await wcfclient.start(
        new priority.netitems.form.StartRq({
            Fname: 'USERLIST',
            Properties: getAdditionalProps()
        })
    );

    const columns = await wcfclient.columns(
        new priority.netitems.form.ColumnsRq({
            Properties: getAdditionalProps(),
            Session: form.Session
        })
    );

    const userNameColumnID = columns.Columns.find(column => column.Name === 'USERNAME')?.ID;
    const userLoginColumnID = columns.Columns.find(column => column.Name === 'USERLOGIN')?.ID;

    const fetch = await wcfclient.recordsFetch(
        new priority.netitems.form.FetchRq({
            Properties: getAdditionalProps(),
            Session: form.Session,
            Top: 1,
            Select: [userNameColumnID], // Select only full name column
            Filters: [
                new priority.netitems.form.Filter({
                    Condition: [
                        new priority.netitems.form.Condition({
                            ColumnID: userLoginColumnID, // Column ID of the nickname
                            Values: [nickName]
                        })
                    ]
                })
            ]
        })
    );

    const record = fetch.Records[0];

    return record?.Fields[0]?.Value?.Str || nickName;
};
